import { ITEM_SLOTS, type ItemSlot } from "@clubap/shared";

/**
 * Nombres visibles de las ranuras. Vive en el cliente porque es presentación: el
 * servidor sólo necesita los identificadores.
 */
export const SLOT_LABELS: Record<ItemSlot, string> = {
  accessory: "Accesorio",
  hat: "Sombrero",
};

/** Ranuras en orden de dibujo, que también sirve para ordenar la UI. */
export const SLOTS_IN_ORDER: readonly ItemSlot[] = ITEM_SLOTS;
